import React, { Component } from 'react'
import { Modal } from 'react-bootstrap'
import { injectIntl } from 'react-intl'
import messages from './messages'

class ContentDateModal extends Component {
  constructor(props) {
    super(props)
    const {
      intl: { formatMessage }
    } = props
    this.formatMessage = formatMessage

    this.state = {}
    this.selectFrom = React.createRef()
    this.selectTo = React.createRef()
  }

	handleApply = () => {
	  let from
	  let to
	  if (this.props.multiple) {
	    if (this.selectFrom.current.selectedOptions) {
	      from = Number(this.selectFrom.current.selectedOptions[0].value)
	    } else {
	      from = Number(this.selectFrom.current.value) // For compatibility with IE11
	    }
	  } else {
	    from = 0
	  }
	  if (this.selectTo.current.selectedOptions) {
	    to = Number(this.selectTo.current.selectedOptions[0].value)
	  } else {
	    to = Number(this.selectTo.current.value)
	  }

	  if (from > to) {
	    return
	  }
	  this.props.fn.setDateRange({ startingYear: from, endingYear: to })
	  this.props.fn.closeModal()
	}

	renderFromOptions = () => {
	  let options = []
	  let year = this.props.minYear

	  while (year <= this.props.maxYear) {
	    options.push(
	      <option key={year} value={year} disabled={year > this.props.endingYear}>
	        {year}
	      </option>
	    )
	    year++
	  }
	  return options
	}

	renderToOptions = () => {
	  let options = []
	  let year = this.props.maxYear

	  while (year >= this.props.minYear) {
	    options.push(
	      <option key={year} value={year} disabled={year < this.props.startingYear}>
	        {year}
	      </option>
	    )
	    year--
	  }
	  return options
	}

	changeFrom = event => {
	  let selectedValue = event.target.value

	  for (let i = 0; i < this.selectTo.current.options.length; i++) {
	    const item = this.selectTo.current.options[i]
	    if (item.value < selectedValue) item.disabled = true
	    else item.disabled = false
	  }
	}

	changeTo = event => {
	  let selectedValue = event.target.value

	  for (let i = 0; i < this.selectFrom.current.options.length; i++) {
	    const item = this.selectFrom.current.options[i]
	    if (item.value > selectedValue) item.disabled = true
	    else item.disabled = false
	  }
	}

	render() {
	  return (
	    <Modal show={this.props.show} onHide={this.props.fn.closeModal}>
	      <Modal.Header closeButton>
	        <Modal.Title id="modal-rango-fechas-01-label">{this.formatMessage(messages.modalTitle)}</Modal.Title>
	      </Modal.Header>
	      <Modal.Body className="ork-modal-body--border-bottom">
	        <form className="form-horizontal">
	          {this.props.multiple ? (
	            <div className="form-group">
	              <label htmlFor="rango-fechas-desde" className="col-sm-5 control-label">
	                {this.formatMessage(messages.modalFrom)}
	              </label>
	              <div className="col-sm-4">
	                <select
	                  ref={this.selectFrom}
	                  className="form-control"
	                  id="rango-fechas-desde"
	                  defaultValue={this.props.startingYear}
	                  onChange={this.changeFrom}
	                >
	                  {this.renderFromOptions()}
	                </select>
	              </div>
	            </div>
	          ) : (
	            ''
	          )}
	          {this.props.multiple ? (
	            <div className="form-group">
	              <label htmlFor="rango-fechas-hasta" className="col-sm-5 control-label">
	                {this.formatMessage(messages.modalTo)}
	              </label>
	              <div className="col-sm-4">
	                <select
	                  ref={this.selectTo}
	                  className="form-control"
	                  id="rango-fechas-hasta"
	                  defaultValue={this.props.endingYear}
	                  onChange={this.changeTo}
	                >
	                  {this.renderToOptions()}
	                </select>
	              </div>
	            </div>
	          ) : (
	            <div className="form-group">
	              <label htmlFor="rango-fechas-hasta" className="col-sm-5 control-label">
	                {this.formatMessage(messages.modalYear)}
	              </label>
	              <div className="col-sm-4">
	                <select ref={this.selectTo} className="form-control" id="rango-fechas-hasta" defaultValue={this.props.endingYear}>
	                  {this.renderToOptions()}
	                </select>
	              </div>
	            </div>
	          )}
	        </form>
	      </Modal.Body>
	      <Modal.Footer>
	        <button type="button" className="btn btn-sm btn-default" data-dismiss="modal" onClick={this.props.fn.closeModal}>
	          <i className="fal fa-times fa-lg" /> <span className="ork-u-ml-half">{this.formatMessage(messages.modalClose)}</span>
	        </button>
	        <button type="button" className="btn btn-sm btn-primary" onClick={this.handleApply}>
	          <i className="fal fa-check fa-lg" /> <span className="ork-u-ml-half">{this.formatMessage(messages.modalApply)}</span>
	        </button>
	      </Modal.Footer>
	    </Modal>
	  )
	}
}

export default injectIntl(ContentDateModal)



// WEBPACK FOOTER //
// ./src/modules/Content/ContentChart/ContentDateModal/ContentDateModal.jsx